import React, { useEffect } from "react";
import api from "../../../api/axios";
import { ROLES } from "../../../constants/roles";
const ReportFilter = ({ filters, setFilters, onSearch }) => {

  const [agents, setAgents] = React.useState([]);

useEffect(() => {
    const fetchAgents = async () => {
      try { 
        const res = await     api.get(`/api/users/by-role/${encodeURIComponent(ROLES.MARKETING_OFFICER)}`)
        setAgents(res.data || []);
      } catch (err) {
        console.error("Failed to load agents", err);
      }
    };

    fetchAgents();
  }
, []);


     
  return (
    <div className="card mb-3 shadow-sm">
      <div className="card-body">
        <div className="row g-3">

          <div className="col-md-3">
            <label className="form-label">Area</label>
            <input
              type="text"
              className="form-control"
              placeholder="type area name"
              onChange={(e) =>
                setFilters({ ...filters, area: e.target.value })
              }
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">Unit Type</label>
            <select
              className="form-select"
              onChange={(e) =>
                setFilters({ ...filters, type_id: e.target.value })
              }
            >
              <option value="">All</option>          
              <option value="1">Flat</option>
              <option value="2">Apartment</option>
              <option value="3">Plot</option>
              <option value="4">Parking</option>
              <option value="5">Shop</option>
            </select>
          </div>
  {/* ✅ Agent Dropdown */}
          <div className="col-md-3">
            <label className="form-label">Agent</label>
            <select
              className="form-select"
              onChange={(e) =>
                setFilters({ ...filters, agent_id: e.target.value })
              }
            >
              <option value="">All Agents</option>
              {agents.map((agent) => (
                <option key={agent.id} value={agent.id}>
                  {agent.name}
                </option>
              ))}
            </select>
          </div>


          <div className="col-md-3">
            <label className="form-label">Start Date</label>
            <input
              type="date"
              className="form-control"
              onChange={(e) =>
                setFilters({ ...filters, from_date: e.target.value })
              }
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">End Date</label>
            <input
              type="date"
              className="form-control"
              onChange={(e) =>
                setFilters({ ...filters, to_date: e.target.value })
              }
            />
          </div>

        </div>

        <div className="mt-3 text-end">
          <button className="btn btn-primary" onClick={onSearch}>
             Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportFilter;
